import { motion } from "framer-motion";
import Seo from "@/components/Seo";
import { useLang } from "@/i18n";
import { legalTranslations } from "@/i18n/legal";

const sections = [
  {
    h2: "1. Oggetto",
    text: "Questi termini regolano l'uso del sito djmagix.net, vetrina dei servizi di DJ Magix (Lugano-Paradiso, Ticino, Svizzera): DJ set per matrimoni, feste private, feste di paese ed eventi aziendali, produzioni musicali e servizi correlati.",
  },
  {
    h2: "2. Preventivi e prenotazioni",
    text: "Le richieste inviate tramite il sito (modulo, telefono, WhatsApp o email) non sono vincolanti: ogni servizio è confermato solo dopo preventivo scritto accettato da entrambe le parti. I prezzi indicati sul sito (a partire da CHF 150) sono indicativi e possono variare in base a durata, location, attrezzatura ed effetti richiesti.",
  },
  {
    h2: "3. Contenuti e proprietà intellettuale",
    text: "Testi, logo, immagini, mix e video presenti su questo sito sono di proprietà di DJ Magix o utilizzati con licenza. Non è consentita la riproduzione o la ridistribuzione senza autorizzazione scritta. I mix in ascolto sono protetti da copyright e destinati al solo ascolto personale.",
  },
  {
    h2: "4. Responsabilità",
    text: "Ci impegniamo a mantenere le informazioni del sito accurate e aggiornate; non garantiamo tuttavia l'assenza di errori. Non rispondiamo di eventuali contenuti di siti esterni raggiungibili tramite link (es. Instagram, mappe).",
  },
  {
    h2: "5. Legge applicabile",
    text: "I presenti termini sono regolati dal diritto svizzero. Per ogni controversia è competente il foro di Lugano (Ticino). Per domande: info@djmagix.net.",
  },
];

const it = {
  title: "Termini di Servizio | DJMAGIX",
  description: "Termini di servizio del sito djmagix.net: preventivi, proprietà intellettuale, responsabilità e legge applicabile.",
  eyebrow: "Documento Legale",
  heading: "Termini di Servizio",
  sections,
};

export default function Termini() {
  const lang = useLang();
  const t = legalTranslations[lang]?.termini || it;
  const path = lang === "it" ? "/termini" : `/${lang}/termini`;
  const alternates = [
    { hreflang: "it", path: "/termini" },
    { hreflang: "en", path: "/en/termini" },
    { hreflang: "de", path: "/de/termini" },
    { hreflang: "x-default", path: "/termini" },
  ];
  return (
    <>
      <Seo title={t.title} description={t.description} path={path} lang={lang} alternates={alternates} />
      <section className="pt-40 pb-24 max-w-3xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <p className="text-xs uppercase tracking-[0.3em] text-[#BFA45D] font-medium text-center">
            {t.eyebrow}
          </p>
          <h1
            data-testid="termini-heading"
            className="font-display text-3xl sm:text-4xl font-bold tracking-tight gold-text mt-4 text-center"
          >
            {t.heading}
          </h1>
          <div className="mt-12">
            {t.sections.map((s) => (
              <div key={s.h2} className="mb-8">
                <h2 className="font-display text-lg sm:text-xl font-semibold text-[#F7DE8B]">
                  {s.h2}
                </h2>
                <p className="text-base text-[#E2C882]/85 leading-relaxed mt-3">{s.text}</p>
              </div>
            ))}
          </div>
        </motion.div>
      </section>
    </>
  );
}
